import { Fragment, ReactElement } from 'react';
import ResearchFamilyNotificationsCivilStatusShared from 'shell/components/shared/research-notifications-civil-status-registry-office/research-family';

const ResearchFamilyNotificationsCivilStatusMotherPage = (): ReactElement => {
  return (
    <Fragment>
      <ResearchFamilyNotificationsCivilStatusShared isMother />
    </Fragment>
  );
};

ResearchFamilyNotificationsCivilStatusMotherPage.displayName =
  'Research Family Notifications CivilStatusMotherPage component';

export default ResearchFamilyNotificationsCivilStatusMotherPage;
